import { render, staticRenderFns } from "./FlipkartDisplay.vue?vue&type=template&id=6f27f5f1&scoped=true&lang=pug"
import script from "./FlipkartDisplay.vue?vue&type=script&lang=js"
export * from "./FlipkartDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27f5f1",
  null
  
)

export default component.exports